import React, { useState } from 'react';
import { SearchBijlesFilters } from './SearchBijlesFilters';

export const SearchBijlesControls: React.FC = () => {
  const [isMapOpen, setIsMapOpen] = useState(false);

  const toggleMap = (): void => {
    setIsMapOpen(!isMapOpen);

    const mapElement = document.getElementById('google-map');
    if (mapElement) {
      if (isMapOpen) {
        mapElement.classList.remove('open');
      } else {
        mapElement.classList.add('open');
      }
    }
  };

  return (
    <div>
      <SearchBijlesFilters />
      <div className={`map_toggle ${isMapOpen ? 'map_open' : ''}`} onClick={toggleMap}>
            Toon op kaart
      </div>
    </div>
  );
};
